// Ordem canônica das categorias exibidas no catálogo e nos chips da hero.
export const CATEGORY_ORDER = [
  'Densitometria Óssea', 'Doppler Vascular', 'Ecocardiografia', 'Mamografia',
  'Medicina Nuclear', 'Cardiologia Funcional', 'PET-CT', 'Ressonância Magnética',
  'Tomografia Computadorizada', 'Ultrassonografia',
];

export const MAX_HERO_EXAM_CHIPS = 6;

// Categorias exibidas nos chips da hero enquanto o catálogo carrega ou falha.
export const HERO_FALLBACK_CHIPS = [
  'Ecocardiografia',
  'Doppler Vascular',
  'Ultrassonografia',
  'Medicina Nuclear',
  'Mamografia',
  'Tomografia Computadorizada',
];

// Deriva os chips da hero a partir das categorias realmente presentes nos
// exames ativos, preservando a ordem canônica do catálogo e o limite.
export function popularExamCategories(exames, { limit = MAX_HERO_EXAM_CHIPS } = {}) {
  const present = new Set((exames || []).map(exame => exame?.categoria).filter(Boolean));
  return CATEGORY_ORDER.filter(category => present.has(category)).slice(0, limit);
}

// Monta a URL do catálogo com a categoria pré-selecionada via ?cat=.
export function heroExamCategoryHref(examsPath, category) {
  const trimmed = String(category || '').trim();
  if (!trimmed) return examsPath;
  return `${examsPath}?cat=${encodeURIComponent(trimmed)}`;
}
